import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/reports/cbVmiReport'
import Component from 'components/Reports/CbVmiReport'

export default createListViewContainer({ actions, selectors: selectors.cbVmiReport })(Component)
